import { useSelector } from "react-redux";

const withSelector = (mapSelect) => (WrappedComponent) => (props) => {
  const selector = useSelector(mapSelect);
  return <WrappedComponent {...props} {...selector} />;
};

export default withSelector;
